import { Dropdown, InlineAlert, Text } from "@amzn/storm-ui";
import styled from "styled-components";

declare type MessageType =
    | "error"
    | "warning"
    | "success"
    | "loading"
    | "info"
    | "opportunity";

const Message = styled(InlineAlert)`
    margin: 0px;
`;

export interface DisabledDropdownProps {
    label: string;
    displayValue: string;
    tooltip?: string;
    messageType?: MessageType;
}

export const DisabledDropdown: React.FunctionComponent<
    DisabledDropdownProps
> = ({ label, displayValue, tooltip, messageType = "info" }): JSX.Element => {
    return (
        <div data-testid={`disabled-dropdown-${label}`}>
            <Dropdown
                fullWidth={true}
                disabled={true}
                label={label}
                selectedLabelOverride={displayValue}
            ></Dropdown>
            {tooltip && (
                <Message
                    variant={messageType}
                    message={<Text renderAs="span">{tooltip}</Text>}
                />
            )}
        </div>
    );
};
